import { FilePen, ServerOff, ShieldCheck } from "lucide-react";
const trustPoints = [{
  id: 1,
  title: "256-BIT AES ENCRYPTION",
  icon: ShieldCheck
}, {
  id: 2,
  title: "AIR-GAPPED INVESTIGATIONS",
  icon: ServerOff
}, {
  id: 3,
  title: "LEGAL COMPLIANCE ASSURED",
  icon: FilePen
}];
export default function ConfidentialityPromise() {
  return <section data-section-id="70774" id="the-security-standard" className="dark bg-background text-foreground py-6">
      <div className="container mx-auto px-4">
        <div className="bg-card/40 border border-primary/20 rounded-sm py-4 px-6 md:px-12 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-16 shadow-2xl shadow-primary/5 backdrop-blur-xl">
          {trustPoints.map((point, i) => {
          const Icon = point.icon;
          return <div key={point.id} data-index={i} className="flex items-center gap-3 group">
                <div className="relative flex items-center justify-center">
                  <div className="absolute inset-0 bg-primary/20 blur-[12px] rounded-full transition-all duration-300 group-hover:bg-primary/40 group-hover:blur-[15px]" />
                  <Icon className="size-5 text-primary relative z-10" />
                </div>
                <span className="text-xs font-mono font-bold text-foreground tracking-widest uppercase">
                  {point.title}
                </span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}